import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class UsersService {

    constructor(private http : HttpClient) { }

    private BASE_URL = environment.apiURL;
    private OPTIONS = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json; charset=UTF-8'
        })
    }

    loadUsersList(){
        let url = this.BASE_URL + "customerManagement/list"
        return this.http.get(url, this.OPTIONS)
    }

    loadRolesFromCompanyUuid(){
      let url = this.BASE_URL + "customerManagement/listRoles"
      return this.http.get(url, this.OPTIONS)
    }

    newUsersCompany(body : any){
      let url = this.BASE_URL + "customerManagement"
      return this.http.post(url, body, this.OPTIONS)
    }

    loadCustomerRoleName(userUuid : any){
      let url = this.BASE_URL + "customerManagement/roleName?uuid=" + userUuid
      return this.http.get(url, this.OPTIONS)
    }

    loadCompanyUserDetail(uuid : any){
      let url = this.BASE_URL + "customerManagement/details?uuid=" + uuid
      return this.http.get(url, this.OPTIONS)
    }

    loadSessionUserDetail(){
      let url = this.BASE_URL + "customerManagement/details/session"
      return this.http.get(url, this.OPTIONS)
    }

    updateCustomer(body : any){
      let url = this.BASE_URL + "customerManagement/update"
      return this.http.post(url, body, this.OPTIONS)
    }

    deleteUser(uuid : any){
      let url = this.BASE_URL + "customerManagement?uuid=" + uuid
      return this.http.delete(url, this.OPTIONS)

    }

}
